import ChatSolution from './ChatSolution'

export default [{
  path: '/project/:project_id/question/:question_id/chatSolution',
  name: 'ChatSolution',
  component: ChatSolution,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Interact'}
}
]



// WEBPACK FOOTER //
// ./src/pages/chatSolution/router.js